/**
 * 实体批量操作器
 * 提供对多个实体的批量操作
 */
export class EntityBatchOperator {
    constructor(entities) {
        this.entities = entities;
    }
    /**
     * 批量添加组件
     * @param component 组件实例
     * @returns 批量操作器
     */
    addComponent(component) {
        for (const entity of this.entities) {
            entity.addComponent(component);
        }
        return this;
    }
    /**
     * 批量移除组件
     * @param componentType 组件类型
     * @returns 批量操作器
     */
    removeComponent(componentType) {
        for (const entity of this.entities) {
            entity.removeComponentByType(componentType);
        }
        return this;
    }
    /**
     * 批量设置活跃状态
     * @param active 是否活跃
     * @returns 批量操作器
     */
    setActive(active) {
        for (const entity of this.entities) {
            entity.active = active;
        }
        return this;
    }
    /**
     * 批量设置标签
     * @param tag 标签
     * @returns 批量操作器
     */
    setTag(tag) {
        for (const entity of this.entities) {
            entity.tag = tag;
        }
        return this;
    }
    /**
     * 批量执行操作
     * @param operation 操作函数
     * @returns 批量操作器
     */
    forEach(operation) {
        this.entities.forEach(operation);
        return this;
    }
    /**
     * 过滤实体
     * @param predicate 过滤条件
     * @returns 新的批量操作器
     */
    filter(predicate) {
        return new EntityBatchOperator(this.entities.filter(predicate));
    }
    /**
     * 获取实体数组
     * @returns 实体数组
     */
    toArray() {
        return this.entities.slice();
    }
    /**
     * 获取实体数量
     * @returns 实体数量
     */
    count() {
        return this.entities.length;
    }
}
//# sourceMappingURL=EntityBatchOperator.js.map